import { resolveZooProductScope } from "../../product-access/productScope";
import React, { Component } from 'react'
import { UserDatabaseConnector } from '../../dataconnector/usersDatabaseConnector'
import PageLoader from '../Common/PageLoader'
import { isResearchGuestProfile, RESEARCH_GUEST_HOME } from '../../utils/users/researchGuest'

const userConnector = new UserDatabaseConnector()

/**
 * Composant de redirection intelligente basée sur le tier du zoo
 * - Discovery: redirige vers FastEvalGroupListView
 * - Autres tiers: redirige vers Dashboard
 */
class DefaultRedirect extends Component {
  async componentDidMount() {
    // Invité recherche (sans parc) : ses projets, en V2, sans lire de parc.
    try {
      const local = await userConnector._getUserData()
      if (isResearchGuestProfile(local?.data) && local.data.akongoStaff !== true) {
        this.props.history.replace(RESEARCH_GUEST_HOME)
        return
      }
    } catch (_error) {
      // Copie locale illisible : comportement habituel.
    }
    try {
      // Récupérer le tier du zoo
      const zooDataResult = await userConnector._getZooData()
      const zooTier = zooDataResult?.data?.followUpLevel || 'essential'

      console.log('DefaultRedirect: Zoo tier detected:', zooTier)

      if (resolveZooProductScope(zooDataResult?.data).mode === 'legacy' && zooTier === 'discovery') {
        // Rediriger vers FastEvalGroupListView pour les zoos Discovery
        console.log('DefaultRedirect: Redirecting to FastEvalGroupListView')
        this.props.history.replace('/FastEvalGroupListView')
      } else {
        // Rediriger vers DashboardNext pour les autres tiers
        console.log('DefaultRedirect: Redirecting to DashboardNext')
        this.props.history.replace('/DashboardNext')
      }
    } catch (error) {
      console.error('DefaultRedirect: Error detecting tier, redirecting to DashboardNext', error)
      // En cas d'erreur, rediriger vers DashboardNext par défaut
      this.props.history.replace('/DashboardNext')
    }
  }

  render() {
    return <PageLoader />
  }
}

export default DefaultRedirect
